<template>
  <section class="home">
    <div class="contenedor-principal">
      <div class="contenedor-imagen">
        <img src="@/assets/images/Imagenes Kia-05.png" alt="Imagen de Kia LiveXperience" class="img-hg">
        <div class="texto-superpuesto">
          <h2 class="titulo">Vive la experiencia Kia DX Studio</h2>
          <p class="descripcion">Una llamada al futuro.</p>
        </div>
      </div>
    </div>
    <imagenPasos />
    <vehiculos />
    <vehiculosSeccion />
    <appKiaDnw />
  </section>
</template>

<script>
import vehiculos from "./vehiculos";
import appKiaDnw from "./appKiaDnw";
import vehiculosSeccion from "./vehiculosSeccion";
import imagenPasos from "./imagenPasos";

export default {
  name: "Home",
  components: {
    vehiculos,
    appKiaDnw,
    vehiculosSeccion,
    imagenPasos,
  },
};
</script>

<style scoped>
.home {
  width: 100%;
  padding-top: 0;
}

.contenedor-principal {
  position: relative;
}

.logo-superpuesto {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}

.img-hg-logo {
  height: 80px;
  max-width: 90%;
}

.linea-divisoria {
  position: absolute;
  top: 18%;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 100%;
  height: 1px;
  background-color: white;
  z-index: 1;
}

.contenedor-imagen {
  position: relative;
  width: 100%;
  max-height: 100%;
  overflow: hidden;
}

.img-hg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.texto-superpuesto {
  position: absolute;
  top: 80%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: white;
  width: 90%;
  max-width: 100%;
  padding: 10px;
  border-radius: 10px;
}

.titulo {
  font-size: 50px;
  font-weight: bold;
  margin-bottom: 10px;
  color: white;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  width: 100%
}

.descripcion {
  font-size: 18px;
  color: white;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

@media (max-width: 768px) {
  .contenedor-imagen {
    max-height: 350px;
  }

  .titulo {
    font-size: 24px;
  }

  .descripcion {
    font-size: 16px;
  }

  .img-hg-logo {
    height: 60px;
  }
}

@media (max-width: 480px) {
  .contenedor-imagen {
    max-height: 250px;
  }

  .titulo {
    font-size: 20px;
  }

  .descripcion {
    font-size: 14px;
  }

  .img-hg-logo {
    height: 50px;
  }
}
</style>
